module.exports = __webpack_public_path__ + "static/media/report-error.b0693f36.png";